import { FC } from 'react'
import { formatUSCurrency } from 'helpers/formatHelpers'

type NetworthAmountProps = {
  amount: string
}

const NetworthAmount: FC<NetworthAmountProps> = ({ amount }) => {
  return (
    <>
      { formatUSCurrency(amount) }
    </>
  )
}

export default NetworthAmount
